// removed by extract-text-webpack-plugin
module.exports = {"card":"_2G2fjneyHPM8trlGCOTVtZ","cardThemeDefault":"_2dk0QLURf0Pka9nIa0OATr","cardHeader":"ecFemF1phUOBrne5Yr5wm","cardThemePrimary":"_1uADiJkiZ1osN9Jl0ws30A","cardThemeInfo":"ctHX186VPqoxsqwagTnaQ","cardThemeSuccess":"_2HbHancpaWE6kJxFCQNBsq","cardThemeWarning":"_2s4m-EffMJo2-JAvEuj0bp","cardThemeDanger":"_5uc6tWLY5EpkaxFCeIG7K","cardHeaderTitle":"_3brUQGjNJGQlu1Hjlyoioy","cardHeaderIcon":"_24DV8hqJHpIwk3DKUo2oYw","cardThumbnail":"_6EINcmQQUtcOebgEiCFZo","cardBody":"_1HtkDbZGGzYJod7OZHeQhI"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/02-organisms/cards/card.scss
// module id = 115
// module chunks = 0